import {
  ContractType,
  UsageSpaceOption,
  UsageSpaceRange,
} from '@immosky/types';

export const availableUsageSpaceOptionsForBuy: UsageSpaceOption[] = [
  {
    text: '0',
    value: 0,
  },
  {
    text: '50',
    value: 50,
  },
  {
    text: '100',
    value: 100,
  },
  {
    text: '150',
    value: 150,
  },
  {
    text: '200',
    value: 200,
  },
  {
    text: '250',
    value: 250,
  },
  {
    text: '300',
    value: 300,
  },
  {
    text: '350',
    value: 350,
  },
  {
    text: '400',
    value: 400,
  },
  {
    text: '450',
    value: 450,
  },
  {
    text: '500',
    value: 500,
  },
  {
    text: '550',
    value: 550,
  },
  {
    text: '600',
    value: 600,
  },
  {
    text: '650',
    value: 650,
  },
  {
    text: '700',
    value: 700,
  },
  {
    text: '750',
    value: 750,
  },
  {
    text: '800+',
    value: Infinity,
  },
];

export const availableUsageSpaceOptionsForRent: UsageSpaceOption[] = [
  {
    text: '0',
    value: 0,
  },
  {
    text: '50',
    value: 50,
  },
  {
    text: '100',
    value: 100,
  },
  {
    text: '150',
    value: 150,
  },
  {
    text: '200',
    value: 200,
  },
  {
    text: '250',
    value: 250,
  },
  {
    text: '300',
    value: 300,
  },
  {
    text: '350',
    value: 350,
  },
  {
    text: '400+',
    value: Infinity,
  },
];

export function getUsageSpaceForContractType(
  contractType: ContractType
): UsageSpaceOption[] {
  switch (contractType) {
    case 'buy':
      return availableUsageSpaceOptionsForBuy;
    case 'rent':
      return availableUsageSpaceOptionsForRent;
  }
}

export const initialUsageSpaceRange: UsageSpaceRange = {
  min: {
    text: '',
    value: 0,
  },
  max: {
    text: '',
    value: 0,
  },
};
